// extracted by mini-css-extract-plugin
export default {"property-type-selector":"property-type-selector-02ca","yes-no-selector":"yes-no-selector-2732"};